import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetPartnerLogoUrl($id: ID!) {
    partner(id: $id) {
      id
      settings {
        id
        appearance {
          chatWidgetPhotoUrl
        }
      }
    }
  }
`);
